import { Component, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import * as fromRoot from '../../../store/reducers';
import { getSelected } from '../../../store/reducers/vpo';
import { VpoName } from '../../../models/vpo.model';
import * as isvek from '../../../../assets/bvi/js/bvi.js';


@Component({
  selector: 'app-site-header',
  templateUrl: './site-header.component.html',
  styleUrls: ['./site-header.component.scss']
})
export class SiteHeaderComponent implements OnInit, OnDestroy {

  private subscriber: any;
  selectedVpo: VpoName;
  //
  isMobile: boolean;
  isClose: boolean;

  constructor(
    private store: Store<fromRoot.AppState>
    ) { }

  ngOnInit() {
    // get list of news
    this.subscriber = this.store
      .pipe(
        select(fromRoot.selectVpoState())
      )
      .subscribe((state: any) => {
        this.selectedVpo = getSelected(state);
       });

    this.isMobile = false;
    // this.deviceService.isMobile();
    // tslint:disable-next-line:no-unused-expression
    new isvek.Bvi();
  }

  ngOnDestroy() {
    this.subscriber.unsubscribe();
  }

  alertClose() {
    this.isClose = true;
  }

}
